angular.module("genericInput.components", []).component("genericInput", {
  templateUrl: "ng/components/genericInput/genericInput.html",
  bindings: {
    /** Input data **/
    inputId: "@",
    inputName: "@",
    inputClass: "@",
    formName: "=",
    bindingVariable: "=",
    /** Optional data **/
    inputDisableOn: "<",
    inputRequired: "<",
    type: "@",
    inputPlaceholder: "@",
    showOn: "<",
    up: "<",
    unique: "<",
    pfIdentifier: "@",
    changes: "&?",
    errorDirection: "@",
    inputTabindex: "@",
    hideMexError: "<",
    initialBindingVariable: "<",
    minValue: "=",
    maxValue: "=",
    /** Disable target on viewvalue present */
    elementToDisable: "@",
    checkWholeForm: "@",
    activeOnlyOnblur: '<',
    checkValidity: '<',
    notVisualTriangle: '<',
    notEraseValueWhenDisable: '=',
    automaticVisualErrorMessage: '<',
    maxLengthInputBox: '<'
  },
  controllerAs: "genericInputCtrl",
  controller: function (
    validationService,
    verifyUniqueService,
    $componentUtility
  ) {
    /** not to loose *this reference **/
    var self = this;

    self.initialized = false;

    self.errorMsgShown = false;

    self.valid = true;

    var getRegex = function () {
      switch (self.type) {
        case "abi":
        case "cab": {
          return new RegExp("^[0-9]{5}$");
        }
        case "ndg": {
          return /^$|^[0-9]{0,8}$/;
        }
        case "cfPiva": {
          return new RegExp(validationService.cfPiva);
        }
        case "cf": {
          return new RegExp(validationService.cfRegex);
        }
        case "password": {
          return new RegExp(validationService.passwordRegex);
        }
        case "piva": {
          return /^[0-7]{1}\d{6}(0{2}[1-9]{1}|0{1}[1-9]{1}\d{1}|100|120|121|888|999)\d{1}$/;
        }
        case "numeric": {
          if (!!self.inputRequired) {
            return new RegExp("^[0-9]+$");
          } else {
            return new RegExp("^[0-9]*$");
          }
        }
        case 'numericFondiBeiHO0': {
          return new RegExp("^([1-9]|1[0-9]{1,2}|[2-9]{1}[0-9]{1}|2[0-4]{1,2}[0-9]{1,2})$");
        }
        case 'numericFondiBeiHO1': {
          return new RegExp("^(2[5-9]{1}[0-9]{1}|[3-9]{1}[0-9]{2}|[1-2]{1}[0-9]{3})$");
        }
        case 'numericFondiBeiDefault': {
          return new RegExp("^([1-9]{1}[0-9]*)$");
        }
        case "alpha": {
          if (!!self.inputRequired) {
            return new RegExp("^[a-zA-Z]+$");
          } else {
            return new RegExp("^[a-zA-Z]*$");
          }
        }
        case "alphaNumeric": {
          return new RegExp("^[a-zA-Z0-9]*$");
        }
        case "alphaWithSpace": {
          return new RegExp("^([a-zA-Z0-9 ]*[,.&']?)*$");
        }
        case "alphaNumericLight": {
          return new RegExp("^([a-zA-Z0-9 ]*[,.&'-]?)*$");
        }
        case "email": {
          return new RegExp(validationService.emailRegex);
        }
        case "mobilePhone": {
          return new RegExp(validationService.phoneRegex);
        }
        case "phone": {
          return new RegExp(validationService.genericPhoneRegex);
        }
        case "cciaa": {
          return new RegExp(validationService.cciaaRegex);
        }
        case "address": {
          return new RegExp(validationService.address);
        }
        case "CAE": {
          return new RegExp(validationService.docTypeCaeRegex);
        }
        case "CAI": {
          return new RegExp(validationService.docTypeCaiRegex);
        }
        case "NCE": {
          return new RegExp(validationService.docTypeNceRegex);
        }
        case "CIE": {
          return new RegExp(validationService.docTypeCieRegex);
        }
        case "PAM": {
          return new RegExp(validationService.docTypePamRegex);
        }
        case "PAT": {
          return new RegExp(validationService.docTypePatRegex);
        }
        case "UCO": {
          return new RegExp(validationService.docTypeUcoRegex);
        }
        case "PAS": {
          return new RegExp(validationService.docTypePasRegex);
        }
        case "numcivic": {
          return new RegExp(validationService.numCivicRegex);
        }
        case "name": {
          return new RegExp(validationService.nameRegex);
        }
        case "CAIBZTN": {
          return new RegExp(validationService.docTypeCaiBolzanoTrentoRegex);
        }
        case "currency": {
          if (!!self.inputRequired) {
            return new RegExp(validationService.currencyRequired);
          } else {
            return new RegExp(validationService.currencyNotRequired);
          }
        }
        case 'currencyForImportPercComponent':
          return new RegExp(validationService.currencyForImportPercentComponent);
          break;

        case 'currencyForImportPercComponentWithSymbol':
          return new RegExp(validationService.currencyForImportPercentComponent);
          break;

        case "cdDestinatario": {
          return new RegExp(validationService.cdDestinatarioRegex);

        }

        case "percentually": {
          if (!!self.inputRequired) {
            return new RegExp(validationService.percentuallyRequired);
          } else {
            return new RegExp(validationService.percentuallyNotRequired);
          }
        }

        case "tasso": {
          return new RegExp(validationService.tassiRegex);
        }

        case "year": {
          return new RegExp(validationService.year);
        }

        case "contractNumber": {
          return new RegExp(validationService.contractNumberRegex);
        }

        case "quoteNumber": {
          return new RegExp(validationService.quoteNumber);
        }

        case "moduleNumber": {
          return new RegExp(validationService.moduleNumberRegex);
        }

        case "permillary": {
          if (!!self.inputRequired) {
            return new RegExp(validationService.permillaryRequired);
          } else {
            return new RegExp(validationService.permillaryNotRequired);
          }
        }

        case "importoTassi": {
          return new RegExp(validationService.importoTassi);
        }

        case "rifAmm": {
          return new RegExp(validationService.rifAmmRegex);
        }

        case "currencyFondiBei": {
          return new RegExp(/^[0-9]*(\,\d{1,5})?$/);
        }

        case "floatingPoint": {
          return new RegExp(validationService.floatingPointNumbers);
        }

        case "floatingPointNumbersWithPoint": {
          return new RegExp(validationService.floatingPointNumbersWithPoint);
        }

        case "alphaSpecialChar": {
          return new RegExp(validationService.alphaNumSpecialChar);
        }
        case "floatingPoint": {
          return new RegExp(validationService.floatingPointNumbers);
        }
        case "url": {
          return new RegExp(validationService.urlRegex);
        }
        case "ragSoc": {
          return new RegExp(validationService.ragSocRegex);
        }
        case "telaio": {
          return new RegExp(validationService.telaio);
        }
        case "targa": {
          return new RegExp(validationService.targa);
        }
        case "otp": {
          return new RegExp(validationService.otp);
        }
        case "otpLogin": {
          return new RegExp(validationService.otpLoginRegex);
        }
        case "cfPivaPlus": {
          return new RegExp(validationService.cfPivaPlus);
        }
        case "preventive": {
          return new RegExp(validationService.numberPreventiveRegex);
        }
        case "numeroGaranzie": {
          return new RegExp(validationService.numGaranzie);
        }
        case "ndgLoginARA": {
          return new RegExp(validationService.ndgRegex)
        }
        case "numIscrizioneAlbo": {
          return new RegExp(validationService.numIscrizioneAlboRegex)
        }
        case "cap": {
          return new RegExp(validationService.capRegex)
        }
        case "codConvenzione": {
          return new RegExp(validationService.codConvenzione);
        }
        case "numOrdineGaranzia": {
          return new RegExp(validationService.ordineGaranzia);
        }
        case "pivaLivigno": {
          return new RegExp(validationService.pivaLivignoRegex)
        }
        case "iban": {
          return new RegExp(validationService.ibanRegex)
        }
        case "codAteco": {
          return new RegExp(validationService.codAteco)
        }
        case "passPhrase": {
          return new RegExp(validationService.passPhrase)
        }
        case "pin": {
          return new RegExp(validationService.pin)
        }
        case "floatingPointNumbersWithPoint": {
          return new RegExp(validationService.floatingPointNumbersWithPoint);
        }
        default: {
          //throw new Error('Error passing attribute TYPE to genericInput, value: ', self.type, ' is not valid!');
          console.info(
            "Error passing attribute TYPE to genericInput, value: ",
            self.type,
            " is not valid!"
          );
        }
      }
    };

    var setValidity = function (bool) {
      if (self.formName && self.inputName && self.formName[self.inputName]) {
        self.formName[self.inputName].$setValidity(self.type, !!bool);
        self.valid = !!bool;
      }
    };

    self.$onInit = function () {
      self.hideMexError = self.hideMexError || false;
      self.verifyUnique = true;
      self.regex = getRegex();

      //Quando viene costruito, check immediato sulla validità
      self.checkGeneric(self.bindingVariable || undefined);

      self.initialized = true;
      if (self.type == "password" || self.type == "passwordARA" || self.type == 'passPhrase' || self.type == 'pin') {
        self.typeOfInput = "password"
      } else {
        self.typeOfInput = "text"
      }
      // if (self.type === 'address') {
      //   self.maxlengthCustom = "30";
      // } else 
      if (self.type === 'year') {
        self.maxlengthCustom = "4";
      } else if (self.type === 'otp') {
        self.maxlengthCustom = "8";
      } else {
        self.maxlengthCustom = self.maxLengthInputBox ? self.maxLengthInputBox : "1000";
      }
      self.errorMsgShown = !!self.automaticVisualErrorMessage;
    };

    self.$onChanges = function (changes) {
      if (changes.type && typeof changes.type != "undefined") {
        if (changes.type.currentValue != changes.type.previousValue) {
          self.regex = getRegex();
        }
      }

      if (changes.checkValidity && typeof changes.checkValidity != "undefined") {
        if (changes.checkValidity.currentValue != changes.checkValidity.previousValue) {
          setValidity(changes.checkValidity.currentValue);
        }
      }

      if (changes.inputDisableOn && typeof changes.inputDisableOn.currentValue != "undefined") {
        jQuery('#' + self.inputId).prop("disabled", !!changes.inputDisableOn.currentValue);
      }


      //Quando l'input si disabilita:
      //1. sbianco il valore
      //2. richiamo il changes per riflettere il cambiamento
      if (
        self.initialized &&
        changes.inputDisableOn &&
        changes.inputDisableOn.currentValue &&
        !changes.inputDisableOn.previousValue &&
        !self.notEraseValueWhenDisable
      ) {
        self.model = undefined;
        //Chiamo changes
        self.changes &&
          self.changes({
            name: self.inputName,
            value: ""
          });
      }
    };

    self.resetAlert = function () {
      self.errorMsgShown = false;
    };

    self.toggleAlertMsg = function () {
      self.errorMsgShown = !self.errorMsgShown;
    };

    self.hasError = function () {
      return !self.valid;
    };

    self.checkGeneric = function (generic, typeOfCall) {
      if (self.activeOnlyOnblur && typeOfCall != 'onBlur') {
        return;
      }
      self.regex = getRegex();
      if (!self.initialized) return;

      /**
       * Se la variabile up viene valorizzata a true
       * di conseguenza la bindingVariable se valorizzata viene messa in maiuscolo
       * 
       */

      if (self.up && self.bindingVariable) {
        self.bindingVariable = self.bindingVariable.toUpperCase();
      }

      /**
       * 2 CASI:
       * 1. generic == undefined
       *  1.1 generic required => non corretto
       *  1.2 generic not required => corretto
       * 2. generic != undefined => corretto
       */
      if (typeof generic == "undefined") {
        setValidity(false);

        self.changes &&
          self.changes({
            name: self.inputName,
            value: self.bindingVariable
          });

        self.verifyUnique = true;

        return;
      } else if (typeof generic == "string" && generic == "") {
        setValidity(!self.inputRequired);

        self.changes &&
          self.changes({
            name: self.inputName,
            value: self.bindingVariable
          });

        self.verifyUnique = true;
        return;
      } else {
        //controllo unicità
        if (self.unique && self.bindingVariable != "") {
          var input = {};
          if (self.type === "email") {
            input = {
              identifier: self.pfIdentifier,
              email: self.bindingVariable
            };
          } else {
            input = {
              identifier: self.pfIdentifier,
              phone: self.bindingVariable
            };
          }

          if (self.bindingVariable) {
            verifyUniqueService
              .verifyAppUniqueItem(input)
              .then(function (response) {
                if (response.success) {
                  if (response.unique) {
                    self.verifyUnique = true;
                    setValidity(true);
                  } else {
                    self.verifyUnique = false;
                    setValidity(false);
                  }
                } else {
                  self.verifyUnique = true;
                }
              });
          }
        } else {
          setValidity(true);
        }
      }

      if (self.type == 'ndg' && typeOfCall == 'onBlur' && generic) {
        var zerosToAdd = Array(9 - generic.toString().length).join('0')
        self.bindingVariable = zerosToAdd + generic
      }
      if (self.type == 'cap' && typeOfCall == 'onBlur' && generic) {
        var zerosToAdd = Array(6 - generic.toString().length).join('0')
        self.bindingVariable = zerosToAdd + generic
      }

      //aggiorno valore esterno
      self.changes &&
        self.changes({
          name: self.inputName,
          value: self.bindingVariable
        });

      setValidity(true);
    };

    self.showHidePass = function () {
      self.typeOfInput = self.typeOfInput == "password" ? "text" : "password";
      self.thisIsPasswor = self.typeOfInput == "text" ? true : false;
    }

  }
});